import { useState } from "react";
import { handleData } from "../../api";

const AdminAddUser = (props) => {

    const { closeShowAddUser, getUserData } = props;
    const initialFormData = {
        gebruikersnaam: "",
        voornaam: "",
        achternaam: "",
        tussenvoegsel: "",
        loginemail: "",
        password: ""
    }
    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        e.preventDefault();
        setFormData({
            ...formData,
            [e.target.name] : e.target.value
        })
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setFormData(initialFormData);
        closeShowAddUser()
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const path = "auth/register";
        const input = formData;
        const data = {
            method: 'POST',
            path: path,
            input: input
        }
        const newUser = await handleData(data);
        getUserData();
        setFormData(initialFormData);
        closeShowAddUser();
    }

    return (
        <>
        <h3>Gebruiker toevoegen</h3>
        <div>
            <form onSubmit={handleSubmit}>

            <div className="aanmeldContainer">
                        <div className="aanmeldInputContainer">
                            <div>
                                <div className="inputBox">
                                    <label htmlFor="gebruikersnaam">Gebruikersnaam</label>
                                    <input 
                                        name ="gebruikersnaam" 
                                        id="gebruikersnaam" 
                                        type="text" 
                                        onChange={handleChange} 
                                        value={formData.gebruikersnaam}
                                        required 
                                        autoFocus />
                                </div>

                                <div className="inputBox">
                                    <label htmlFor="loginemail">Loginemail</label>
                                    <input 
                                        name="loginemail" 
                                        id="loginemail" 
                                        type="email" 
                                        onChange={handleChange} 
                                        value={formData.loginemail} 
                                        required/>
                                </div>

                                <div className="inputBox">
                                    <label htmlFor="password">Wachtwoord</label>
                                    <div className="passwordContainer">
                                        <input 
                                            name="password" 
                                            id="password" 
                                            type="text" 
                                            onChange={handleChange} 
                                            value={formData.password} 
                                            required/>

                                    </div>
                                </div>

                                <div>
                                    <div className="inputBox">
                                        <label htmlFor="voornaam">Voornaam</label>
                                        <input 
                                            name="voornaam" 
                                            id="voornaam" 
                                            type="text" 
                                            onChange={handleChange} 
                                            value={formData.voornaam} 
                                            required />
                                        
                                        <div className="achternaamContainer">
                                            <div className="inputBox" >
                                                <label htmlFor="achternaam">Achternaam</label>
                                                <input 
                                                    name="achternaam" 
                                                    id="achternaam" 
                                                    type="text" 
                                                    onChange={handleChange} 
                                                    value={formData.achternaam} 
                                                    required/>
                                            </div>
                                            <div className="inputBox">
                                                <label htmlFor="tussenvoegsel">Tussenvoegsel</label>
                                                <input 
                                                    name="tussenvoegsel" 
                                                    id="tussenvoegsel" 
                                                    type="text" 
                                                    onChange={handleChange} 
                                                    value={formData.tussenvoegsel} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button onClick={handleCancel}>Cancel</button>
                        <button>Submit</button>

                    </div>
            </form>
        </div>
        </>
    );
}

export default AdminAddUser;